<template>
  <section class="section solution">
    <!-- <p class="title">
            <span class="dark-orange">Извънредни плащания.</span>
            <span class="has-text-grey">Гъвкаво финансиране.</span>
    </p>-->
    <!-- <p class="title"> -->
    <!-- Извънредни плащания. Гъвкаво финансиране. -->
    <!-- <span class="dark-orange">Спешни плащания.</span>
            <br class="is-hidden-tablet">
    <span class="has-text-info">Бизнес финансиране.</span>-->
    <!-- </p> -->
    <!-- <p>Финансирането най-често е свързано с бюрокрация.
          <strong>Не и при нас!</strong>
          <br><br>
          Когато възникнат <strong>спешни плащания</strong>, банковият сектор няма да реши проблема.
          Ще получите кредит когато вече не ви е необходим!</p>
          <br>
    <p class="dark-orange"><strong>Решението е</strong> да се обърнете към компания, която ще ви осигури финансиране в рамките на <strong>3 дни</strong>.</p>-->
    <div class="columns is-centered is-gapless">
      <div class="column is-half has-text-left">
        <div class="solution-content">
          <h1 class="title">Ипотечен кредит</h1>

          <h2 class="title">без бюрокрация</h2>

          <div class="content">
            <p>
              <strong>ИПО ФИНАНС</strong> ви предоставя изгодно
              <strong>ипотечно</strong> кредитиране. Ще ви предложим облекчени условия, гратисен период, безлихвен период и гъвкав погасителен план.
            </p>

            <p class="hero-button">
              <button
                class="button is-rounded hero"
                @click.prevent="$eventBus.scrollTo('application-form')"
              >ВЗЕМИ ИПОТЕЧЕН КРЕДИТ</button>
            </p>

            <br>

            <!-- <div class="tabs is-small is-fullwidth">
                    <ul>
                      <li><a @click.prevent="$eventBus.scrollTo('products')">КРЕДИТИ</a></li>
                      <li><a @click.prevent="$eventBus.scrollTo('p-plans')">ПЛАН</a></li>
                      <li><a @click.prevent="$eventBus.scrollTo('powers')" >ПРЕДИМСТВА</a></li>
                      <li><a @click.prevent="$eventBus.scrollTo('about')">ЗА&nbsp;НАС</a></li>
                      <li><a @click.prevent="$eventBus.scrollTo('footer')">КОНТАКТИ</a></li>
                    </ul>
            </div>-->
          </div>
        </div>
      </div>

      <!-- <div class="column is-2">
      </div>-->
      <!-- TABLE -->
      <div class="column is-half">
        <div class="solution-table">
          <table class="table is-bordered is-narrow is-fullwidth">
            <thead>
              <tr>
                <th colspan="2">Ипотечни кредити до 150'000 € (293'374.50 лв). До 3 дни.</th>
              </tr>
            </thead>
            <!-- <tfoot>
                    <tr>
                      <th>...</th>
                      <th>...</th>
                    </tr>
            </tfoot>-->
            <tbody>
              <tr>
                <td>Размер</td>
                <td>
                  от
                  <b>5'000</b>&nbsp;€ (9'779.15&nbsp;лв) до
                  <b>150'000</b>&nbsp;€ (293'374.50&nbsp;лв)
                </td>
              </tr>
              <tr>
                <td>Срок</td>
                <td>
                  от
                  <b>3</b> месеца до
                  <b>10</b>&nbsp;години
                </td>
              </tr>
              <tr>
                <td>Предварително одобрение</td>
                <td>
                  <b>1</b>&nbsp;ден
                </td>
              </tr>
              <tr>
                <td>Усвояване на кредита</td>
                <td>
                  до
                  <b>3</b> дни
                </td>
              </tr>
              <tr>
                <td>Погасителни планове</td>
                <td>
                  <small>
                    <a>анюитетен</a>,&nbsp;
                    <a>само лихва</a>,&nbsp;
                    <a>кредитна линия</a>
                  </small>
                </td>
              </tr>
              <tr>
                <td>Такса за разглеждане</td>
                <td>
                  <b>няма</b>
                </td>
              </tr>
              <tr>
                <td>Такса за усвояване</td>
                <td>
                  <b>няма</b>
                </td>
              </tr>
              <tr>
                <td>Такса за обслужване</td>
                <td>
                  <b>няма</b>
                </td>
              </tr>
              <tr>
                <td>Оценка на обезпечението</td>
                <td>
                  <b>0 € (0 лв)</b>
                  <small>(безплатна оценка)</small>
                </td>
              </tr>
              <tr>
                <td>Възможно обезпечение</td>
                <td>
                  <small>апартамент, къща, магазин, офис,
                    <br>парцел, земеделска земя ...
                  </small>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <strong>Въвеждане на еврото</strong>
                  <p>Договори за кредит, сключени преди 01.01.2026г остават с непроменен лихвен процент след въвеждане на Еврото (съгласно чл. 44 ал. 4 от Закона за въвеждане на еврото в Република България)
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Solution'
}
</script>

<style lang="stylus" scoped>
.section {
  // background red
  padding: 100px 0;
}

.solution-content {
  margin: auto;
  width: 62%;
}

.solution-table {
  margin: auto;
  width: 90%;
}

h1.title {
  margin-bottom: 0;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 54px; // 56
}

h2.title {
  text-transform: uppercase;
  font-weight: 300;
  font-size: 23px; // 24px
}

.content > p {
  color: #5f727f;
  font-weight: 300;
  font-size: 20px;
}

& .hero-button {
  margin: 35px auto 0 auto;

  & .button {
    // margin auto
  }
}

// TABLE
.table {
  font-size: 14px;

  thead th {
    padding: 10px;
    height: 35px;
    // background #209cee - 15%
    // background #cc3300 + 12%
    background: #191919;
    color: white;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    opacity: 0.7;
  }

  tbody td {
    color: black;
  }

  tbody tr:nth-child(odd) {
    // background #209cee + 95%
    // background #cc3300 + 95%
    background: #f5f5f5;
  }

  tbody tr:nth-child(even) {
    // background #209cee + 90%
    // background #cc3300 + 90%
    background: #FAFAFA;
  }
}

// @MEDIA
// <<< 768px
@media (max-width: 768px) {
  .solution-content, .solution-table {
    margin: auto;
    width: 90%;
  }

  .button {
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Solution.vue